import { css } from '@emotion/react';
import Tooltip from '@mui/material/Tooltip';

import { buildBreakdownParts, statePriority, taskStateColor } from 'utils/taskStateColors';

export default function TaskStateBar({ counts }: { counts: Record<string, number> }) {
  const entries = Object.entries(counts)
    .filter(([, count]) => count > 0)
    .sort(([a], [b]) => statePriority(a) - statePriority(b));

  if (entries.length === 0) {
    return null;
  }

  const breakdown = buildBreakdownParts(counts).join(', ');

  return (
    <Tooltip title={breakdown}>
      <div
        role="img"
        aria-label={`Task states: ${breakdown}`}
        tabIndex={0}
        css={css`
          display: flex;
          width: 120px;
          height: 10px;
          border-radius: 5px;
          overflow: hidden;
        `}
      >
        {entries.map(([state, count]) => (
          <div
            key={state}
            css={css`
              min-width: 3px;
            `}
            style={{ flexGrow: count, backgroundColor: taskStateColor(state) }}
          />
        ))}
      </div>
    </Tooltip>
  );
}
